module.exports = __webpack_public_path__ + "static/media/tutorial_mobile.15dea9e5.webp";